import { InputDropdownItem } from '@platform/components';
import { ApplicationPageProps } from '../../Application';
import { ReferralSelection } from '../shared/ReferralSelection';



const SAP_REFERRAL_OPTIONS: InputDropdownItem[] = [
	{ text: 'A colleague within your company', textValue: 'A colleage within your company' },
	{ text: 'Your manager', textValue: 'Your manager' },
	{ text: 'Your Global CSR leader', textValue: 'Your Global CSR leader' },
	{ text: 'Your Regional CSR leader', textValue: 'Your Regional CSR leader' },
	{
		text: 'Email communication from your company',
		textValue: 'Email communication from your company',
	},
	{ text: 'Internal meeting or town hall', textValue: 'Internal meeting or town hall' },
	{ text: 'LinkedIn', textValue: 'LinkedIn' },
	{ text: 'Other', textValue: 'Other' },
];

export const SAPReferralSelection = (props: ApplicationPageProps) => {

	return (
		<ReferralSelection
			{...props}
			referralOptions={SAP_REFERRAL_OPTIONS}
			programTermsText={<div>
				I've reviewed and agree to{' '}
				<a
					className='underline'
					href='https://drive.google.com/file/d/1E6cl50FoizvcuMFutKNA4tZpv7ukiZQQ/view?usp=drive_link'
				>
					the liability release document
				</a>{' '}
				and{' '}
				<a
					className='underline'
					href='https://drive.google.com/file/d/15Q_EH7BlthYwvKxhaHaHtRqUXCzi5M_X/view?usp=drive_link'
				>
					media release document
				</a>
			</div>}
			programTermsErrorText='Agree to the liability release document and media release document to submit your application'
		/>
	);
};
